import Page from "src/components/Report/Page";
import { Radar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend,
} from 'chart.js';
import { useLocation } from "react-router-dom";

ChartJS.register(
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend
);
export default function Page4() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const jobId = params.get("id");
    let jobTitle;
    if (localStorage?.data && JSON.parse(localStorage?.data)?.[jobId].baseInfo) {
        jobTitle = JSON.parse(localStorage?.data)?.[jobId].baseInfo.jobTitle;
    }
    let mokhateratShoghli1 = null;
    let labels1 = [];
    let labelsData1 = [];
    if (localStorage?.data && JSON.parse(localStorage?.data)?.[jobId].mokhateratShoghli1) {
        mokhateratShoghli1 = JSON.parse(localStorage?.data)?.[jobId].mokhateratShoghli1
        Object.keys(mokhateratShoghli1).map((key, index) => {
            if (mokhateratShoghli1[key].value >= 0) {
                if (key.substring(0, 40) == key) {
                    labels1.push(key);
                } else {
                    labels1.push(key.substring(0, 40) + "...");
                }
                labelsData1.push(mokhateratShoghli1[key].value);
            }
        })
    }

    const data1 = {
        labels: labels1,
        datasets: [
            {
                data: labelsData1,
                backgroundColor: '#1e3a8a88',
                borderColor: '#1e3a8a',
                borderWidth: 1,
            },
        ],
    };
    const options = {
        plugins: {
            legend: {
                display: false
            }
        },
        scales: {
            r: {
                pointLabels: {
                    font: {
                        size: "14px",
                        family: "iransans",
                        weight: "900"
                    }, // Adjust the font size as desired
                }
            },
            // suggestedMin: 2, // Define the minimum value for the chart
            // suggestedMax: 5,
        },
    };



    let mokhateratShoghli2 = null;
    let labels = [];
    let labelsData = [];
    if (localStorage?.data && JSON.parse(localStorage?.data)?.[jobId].mokhateratShoghli2) {
        mokhateratShoghli2 = JSON.parse(localStorage?.data)?.[jobId].mokhateratShoghli2
        Object.keys(mokhateratShoghli2).map((key, index) => {
            if (mokhateratShoghli2[key].value >= 0) {
                if (key.substring(0, 40) == key) {
                    labels.push(key);
                } else {
                    labels.push(key.substring(0, 40) + "...");
                }
                labelsData.push(mokhateratShoghli2[key].value);
            }
        })
    }

    const data = {
        labels: labels,
        datasets: [
            {
                data: labelsData,
                backgroundColor: '#1e3a8a88',
                borderColor: '#1e3a8a',
                borderWidth: 1,
            },
        ],
    };




    let mokhateratShoghli3 = null;
    let labels3 = [];
    let labelsData3 = [];
    if (localStorage?.data && JSON.parse(localStorage?.data)?.[jobId].mokhateratShoghli3) {
        mokhateratShoghli3 = JSON.parse(localStorage?.data)?.[jobId].mokhateratShoghli3
        Object.keys(mokhateratShoghli3).map((key, index) => {
            if (mokhateratShoghli3[key].value >= 0) {
                if (key.substring(0, 15) == key) {
                    labels3.push(key);
                } else {
                    labels3.push(key.substring(0, 15) + "...");
                }
                labelsData3.push(mokhateratShoghli3[key].value);
            }
        })
    }

    const data3 = {
        labels: labels3,
        datasets: [
            {
                data: labelsData3,
                backgroundColor: '#1e3a8a88',
                borderColor: '#1e3a8a',
                borderWidth: 1,
            },
        ],
    };


    let mokhateratShoghli4 = null;
    let labels4 = [];
    let labelsData4 = [];
    if (localStorage?.data && JSON.parse(localStorage?.data)?.[jobId].mokhateratShoghli4) {
        mokhateratShoghli4 = JSON.parse(localStorage?.data)?.[jobId].mokhateratShoghli4
        Object.keys(mokhateratShoghli4).map((key, index) => {
            if (mokhateratShoghli4[key].value >= 0) {
                if (key.substring(0, 15) == key) {
                    labels4.push(key);
                } else {
                    labels4.push(key.substring(0, 15) + "...");
                }
                labelsData4.push(mokhateratShoghli4[key].value);
            }
        })
    }

    const data4 = {
        labels: labels4,
        datasets: [
            {
                data: labelsData4,
                backgroundColor: '#1e3a8a88',
                borderColor: '#1e3a8a',
                borderWidth: 1,
            },
        ],
    };

    let mokhateratShoghli = { ...mokhateratShoghli1, ...mokhateratShoghli2, ...mokhateratShoghli3, ...mokhateratShoghli4 }
    return (
        <Page pageNumber={5}>
            <div className="font-bold text-lg">
                <span> ‌مخاطرات شغلی ‌</span>
                <span className="text-xs font-light">(احتمال مواجهه با عوامل مكانیكی زیان آور دراین شغل چقدر است؟)</span>
            </div>
            <p className="text-black text-justify">
                مخاطرات شغلی به مجموعه عوامل فیزیکی، روانی، ارگونومیک یا شغلی اطلاق می‌شود که ممکن است سلامت، ایمنی یا عملکرد فرد را در محیط کار تهدید کنند. این مخاطرات بسته به نوع شغل شامل مواردی مانند کار در ارتفاع، مواجهه با مواد شیمیایی، فشار روانی، یا کار با تجهیزات حساس می‌باشند. شناسایی و درج این بخش در تحلیل شغل، مبنایی برای طراحی اقدامات پیشگیرانه، آموزش ایمنی و پوشش بیمه‌ای فراهم می‌سازد. هدف از آن، کاهش ریسک و ارتقاء سلامت حرفه‌ای کارکنان است.
            </p>
            <div className="grid grid-cols-2 mt-5">
                <div className="border-2 border-gray-400 flex w-full justify-center flex-col rounded-md">
                    <span className="w-[250px] m-auto flex justify-center bg-[#fab402] text-white p-1 rounded-b-md">مخاطرات مکانیکی</span>
                    <Radar data={data1} options={options} />
                </div>
                <div className="border-2 border-r-0 border-gray-400 flex w-full justify-center flex-col rounded-md">
                    <span className="w-[250px] m-auto flex justify-center bg-[#fab402] text-white p-1 rounded-b-md">ایجاد ناتوانی</span>
                    <Radar data={data} options={options} />
                </div>
                <div className="border-2 border-gray-400 border-t-0 flex w-full justify-center flex-col rounded-md">
                    <span className="w-[250px] m-auto flex justify-center bg-[#fab402] text-white p-1 rounded-b-md">مواجه با عوامل زیان آور</span>
                    <Radar data={data3} options={options} />
                </div>
                <div className="border-2 border-r-0 border-gray-400  border-t-0 flex w-full justify-center flex-col rounded-md">
                    <span className="w-[250px] m-auto flex justify-center bg-[#fab402] text-white p-1 rounded-b-md">عوامل ارگونومیکی</span>
                    <Radar data={data4} options={options} />
                </div>
            </div>
            <p className="rounded-lg p-4 text-justify">
                با توجه به اطلاعات برآمده از تحلیل، در شغل "{jobTitle}" عواملی همچون ‌
                <span className="text-gray-800">
                    {mokhateratShoghli &&
                        Object.keys(mokhateratShoghli).sort(function (a, b) { return mokhateratShoghli[b].value - mokhateratShoghli[a].value }).map((key, index) => {
                            if (index < 7) {
                                return (key) + "، "
                            }
                        })}
                </span>
                ‌صاحبان این شغل را بیش از سایر عوامل تهدید می‌کند.
            </p>
            {/* <div className="flex w-[550px] justify-center items-center m-auto">
                <Radar data={data1} options={options} />
            </div>
            <div className="font-bold text-lg">
                <span> ‌مخاطرات شغلی ‌</span>
                <span className="text-xs font-light">(احتمال ایجاد ناتوانی های ذیل در این شغل چقدر است ؟)</span>
            </div>
            <div className="flex w-[550px] justify-center items-center m-auto">
                <Radar data={data} options={options} />
            </div> */}
        </Page>
    )
}